import { Image, useColorModeValue } from '@chakra-ui/react';
import DarkLogo from 'assets/image/amatrium_gpt_dark.png';
import LightLogo from 'assets/image/amatrium_gpt_light.png';

function AmatriumLogo({ width }) {
  const logo = useColorModeValue(DarkLogo, LightLogo);
  return <Image w={width} src={logo} />;
}

export default AmatriumLogo;
